<template>
    <div class="eva-item">
        <Header title="即时评教" type="0" route="/homeIndex" :casLogin="casLogin"></Header>
        <div class="noticeDiv">
            <div><van-notice-bar color="red"  scrollable left-icon="volume-o">为保障同学们的权益，此评价为匿名评价。请各位同学秉承着实事求是的态度，客观评价老师上课情况。</van-notice-bar></div>
        </div>
        <NOdata v-if="evaluateList.length == 0" title="暂无评教数据~"></NOdata>
        <div class="evaluate_content">
            <div v-for="(item, index) in evaluateList" :key="index" @click="teachEva(item)">
                <div>
                    <h4>{{ item.kcmc }}</h4>
                    <p>上课老师：{{ item.jgxm }}</p>
                    <p>上课时间：{{ item.sksj }}</p>
                    <p>上课地点：{{ item.skdd }}</p>
                </div>
                <span class="icon_right"></span>
            </div>
        </div>
    </div>
</template>

<script>
import { Api } from '../../../utils/axios';
export default {
    data() {
        return {
            casLogin: sessionStorage.getItem('casLogin'),
            evaluateList: [],
        };
    },
    created() {
        this.getEvaluate();
    },
    methods: {
        async getEvaluate() {
            const res = await Api.getEvaluateOnTimeApi();
            this.evaluateList = res.data;
        },
        teachEva(obj) {
            let p = '/student/teachEvaluateOnTime';
            this.$router.push({
                path: p,
                query: {
                    dataObj: JSON.stringify(obj)
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.noticeDiv{
    height: 50px;
    position:fixed ;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 999;
    padding-left: 20px;
    padding-right: 20px;
}
.evaluate_content{
    margin-top: 80px;
}
.eva-item .evaluate_content {
    font-family: PingFangSC;
    padding: 20px;
}
.eva-item .evaluate_content > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: @attendance-background-color-10;
    padding: 10px 20px;
    box-sizing: border-box;
    color: @attendance-color-2;
    margin-bottom: 15px;
    border-radius: 5px;
    position: relative;
}
.eva-item .evaluate_content > div::after {
    position: absolute;
    content: '';
    background-color: @attendance-background-color-1;
    width: 3px;
    left: 0;
    border-radius: 5px 0 0 5px;
    height: 100%;
}
.eva-item .evaluate_content > div p {
    color: @attendance-color-2;
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 2px;
}
.eva-item .evaluate_content > div h4 {
    color: @attendance-color-1;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 4px;
}
.eva-item .evaluate_content div .icon_right {
    height: 15px;
    width: 15px;
    background: url(../../../../static/img/arrow.png) center center no-repeat;
    background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/evaluateOnTime.vue